import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';

import { config } from '@platform/constants';
import { httpService } from '@shared/utilities';
import { AscResponse } from '@shared/models';
import * as Response from '@shared/models/rank/rank.response.type';
import * as Request from '@shared/models/rank/rank.request.type';
import { formatErrorMessage } from '@ascendnow/ascend-components';

import { setGlobalList, setSchoolList } from '../slices';
import { RootState } from '../..';

export const RankEndpoints = {
    getRankList: config.base_url + '/ranks',
};

export const getRankListQuery = createAsyncThunk<void, Request.IFetchGlobalRankQuery>(
    RankEndpoints.getRankList,
    async (query, { dispatch, getState }) => {
        try {
            const { type, period, skip, take, schoolName } = query.params;
            const queryParams = qs.stringify({
                type,
                period,
                ...(schoolName ? { schoolName } : {}),
                ...(skip && take ? { skip, take } : {}),
            });
            const res = await httpService.get<AscResponse<Response.IRankListResponse>>(
                `${RankEndpoints.getRankList}?${queryParams}`
            );

            const store = getState() as RootState;

            if (type === 'school') {
                dispatch(
                    setSchoolList(
                        Number(skip) > 0
                            ? {
                                  ...res.data.data,
                                  data: [...store.rank.schoolList, ...res.data.data.data],
                              }
                            : res.data.data
                    )
                );
            } else {
                dispatch(
                    setGlobalList(
                        Number(skip) > 0
                            ? {
                                  ...res.data.data,
                                  data: [...store.rank.globalList, ...res.data.data.data],
                              }
                            : res.data.data
                    )
                );
            }

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(formatErrorMessage(err, `Error fetching rank list, query: ${RankEndpoints.getRankList}`), {
                type: 'error',
            });
        }
    }
);
